const SecurityEnum = {
    ActiveSessions: 0,
    ActivityLog: 2,
    TwoFactor: 3,
    TrustedBrowsers: 1,
    Passkey: 4,
    AccountSecurity: 5,
}

Object.freeze(SecurityEnum);

export default SecurityEnum;